import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {CookieService} from 'ngx-cookie-service';
import {AgGridModule} from 'ag-grid-angular';
import {AppComponent} from './app.component';
import {LoginComponent} from './login/login.component';
import {Globals} from './globals';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ToastrModule} from 'ngx-toastr';
import {HeaderComponent} from './form/header/header.component';
import {ApplicationListComponent} from './application-list/application-list.component';
import {PreventDoubleSubmitModule} from 'ngx-prevent-double-submission';
import {ApplicationFormComponent} from './application-form/application-form.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HeaderComponent,
    ApplicationListComponent,
    ApplicationFormComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    PreventDoubleSubmitModule.forRoot(),
    AgGridModule.withComponents(null),
    NgbModule
  ],
  providers: [Globals, CookieService],
  bootstrap: [AppComponent]
})
export class AppModule {
}
